import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import Select2Multiple from 'v-select2-multiple-component';
import MainLayout from "@/components/layout/admin/MainLayout.vue";
import axios from "axios";
import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import CONFIG from "@/assets/js/config.js";
import store from '../../store';
import {
  mapGetters
} from "vuex";
import {
  required
} from "vuelidate/lib/validators";

export default {
  name: "StudentList",
  components: {
    MainLayout,
    flatPickr,
    Select2Multiple,
    AdvancedLaravelVuePaginate,
    Loading
  },

  data() {
    return {
      noDataMsg: CONFIG.NO_DATA_FOUND,
      name: '',
      parentNo: '',
      grade_id: '',
      campus_id: '',
      section_id: '',
      gender: '',
      phone: '',
      year: '',
      selectedGrade: 0,
      selectedSection: 0,
      selectedGender: 0,
      selectedYear: 0,
      gradeArr: [],
      sectionArr: [{
        "id": 0,
        "text": "All"
      }],
      academicYearArr: null,
      currentAndNextYearArr: null,
      studentList: {},
      leavedStudentList: {},
      genderArr: [{
        id: 0,
        text: 'All'
      },
      {
        id: 1,
        text: 'Male'
      },
      {
        id: 2,
        text: 'Female'
      }
      ],
      isLoading: false,
      search_status: false,
      leaved_search_status: false,
      submitted: false,
      invalidFile: false,
      disabled: false,
      templatelLink: '',
      studentFile: '',
      studentFileName: '',
      maxGradeId: 0,
      clickDisabled: false,
      checkAll: false,
      nextPageCheckAll: false,
      selectedCb: [],
      searchSelectedCb: [],
      unSelectedCb: [],
      idArray: [],
      passFailDisable: false,
      tmpClasses: [],
      saveIndexes: [],
      requiredClass: false,
      requiredYear: false,
      classArr: null,
      year_id: 0,
      class_id: 0,
      passFailResult: 0,
      activeCurrentPage: 1,
      leavedCurrentPage: 1,
      searchedData: null,
      isSearched: false,
    };
  },

  computed: {
    ...mapGetters(['getUser']),
    searchParams() {
      return {
        name: this.name,
        parent_no: this.parentNo,
        phone: this.phone,
        grade_id: this.grade_id,
        section_id: this.section_id,
        gender: this.gender,
        year: this.year,
        campus_id: store.state.user.campus_id,
      };
    },

  },

  validations: {
    studentFile: {
      required
    }
  },

  methods: {
    getAcademicYear() {
      axios.get('getAcademicYear', {
        params: {
          campus_id: store.state.user.campus_id
        }
      })
        .then(res => {
          let $defaultSelectOption = [{
            'id': 0,
            'text': 'Select'
          }];
          this.academicYearArr = $defaultSelectOption.concat(res.data.academicYearArr);
        }).catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    getCurrentAndNextYear() {
      axios.get('period/get-current-next', {
        params: {
          campus_id: store.state.user.campus_id
        }
      })
        .then(res => {
          let $defaultSelectOption = [{
            'id': 0,
            'text': 'Select'
          }];
          this.currentAndNextYearArr = $defaultSelectOption.concat(res.data);
        }).catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    selectAll() {
      this.selectedCb = [];
      if (!this.checkAll) {
        if (this.search_status) {
          this.searchSelectedCb = this.idArray;
          this.nextPageCheckAll = true;
          this.checkAll = true;
          // this.unSelectedCb = [];
        } else {
          this.selectedCb = this.idArray;
          this.nextPageCheckAll = true;
          this.checkAll = true;
          // this.unSelectedCb = [];
        }
      } else {
        this.checkAll = false;
        this.nextPageCheckAll = false;
        this.selectedCb = [];
        this.searchSelectedCb = [];
      }
    },

    updateCheckall(e, sId) {
      let maxCbTotal = this.studentList.total;
      if (!e.target.checked) {
        this.unSelectedCb = this.unSelectedCb.concat(sId);
        this.unSelectedCb = [...new Set(this.unSelectedCb)];
      } else {
        const filtersList = this.unSelectedCb.filter(element => element !== sId);
        this.unSelectedCb = filtersList;

        this.unSelectedCb = [...new Set(this.unSelectedCb)];
      }
      // if allcheck is clicked and then single uncheck ( checkAll is false and nexPage is all checked )
      if (!this.nextPageCheckAll) {
        if (this.search_status) {
          if (maxCbTotal == this.searchSelectedCb.length) {
            this.checkAll = true;
          } else {
            this.checkAll = false;
          }
        } else {
          if (maxCbTotal == this.selectedCb.length) {
            this.checkAll = true;
          } else {
            this.checkAll = false;
          }
        }
      } else {
        if (maxCbTotal == this.studentList.total - this.unSelectedCb.length) {
          this.checkAll = true;
        } else {
          this.checkAll = false;
        }
      }
    },

    getGradeNameByAcademicYear(yearId) {
      if (yearId == 0) return;
      axios.get('getGradeNameByAcademicYear?id=' + yearId, {
        params: {
          campus_id: store.state.user.campus_id
        }
      }).then(res => {
        let $defaultSelectOption = [{
          "id": 0,
          "text": "All"
        }];
        this.gradeArr = $defaultSelectOption.concat(res.data);
        this.isLoading = false;
      }).catch((error) => {
        if (error.response.status == 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        }
        this.isLoading = false;
      });
    },

    getMaxGradeByCampus() {
      var request = {
        params: {
          campus_id: store.state.user.campus_id
        }
      }
      axios.get("/grade/getMaxGradeIdByCampus", request).then((response) => {
        this.maxGradeId = response.data;
      })
        .catch(error => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    getClass($yearId) {
      axios.get("class/classList/" + $yearId, {
        params: {
          campus_id: this.$store.state.user.campus_id,
        }
      })
        .then(res => {
          let $defaultSelectOption = [{
            'id': 0,
            'text': 'Select Class'
          }];
          this.classArr = $defaultSelectOption.concat(res.data);
          this.isLoading = false;
        }).catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    handlePassClick(studentInfo) {
      this.showModel(
        studentInfo.student.current_year_student_grade.length > 0
          ? studentInfo.student.current_year_student_grade[0].id
          : studentInfo.student.student_grade[0].id,
        1
      );
    },

    handleFailClick(studentInfo) {
      this.showModel(
        studentInfo.student.current_year_student_grade.length > 0
          ? studentInfo.student.current_year_student_grade[0].id
          : studentInfo.student.student_grade[0].id, 0
      );
    },

    getStudentList(page = 1) {
      var request = {
        params: {
          campus_id: store.state.user.campus_id
        }
      }
      // axios.get("/student/list?page=" + page, request)
      axios.get("/student/active/list?page=" + page, request)
        .then(response => {
          this.deleterow();
          this.search_status = false;
          this.studentList = response.data;
          this.idArray = [];
          this.studentList.data.forEach(e => {
            if (e.status !== 1 && e.result == null) {
              this.idArray.push(e.class_student_id);
            }
            if (e.result != null) {
              this.unSelectedCb.push(e.class_student_id);
            }
          });
          if (this.checkAll || this.nextPageCheckAll) {
            this.unSelectedCb = new Set(this.unSelectedCb);
            let removedArr = this.idArray.filter((name) => {
              return !this.unSelectedCb.has(name);
            });

            this.selectedCb = this.selectedCb.concat(removedArr);
            this.selectedCb = [...new Set(this.selectedCb)];
            this.idArray = this.idArray.concat(this.idArray);
            this.idArray = [...new Set(this.idArray)];
            this.unSelectedCb = [...new Set(this.unSelectedCb)];
          }
        })
        .catch(error => {
          if (error.response && error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
          console.log("Student List API Error", error);
        });
    },

    getLeavedStudentList(page = 1) {
      var request = {
        params: {
          campus_id: store.state.user.campus_id
        }
      }
      axios.get("/student/leavedList?page=" + page, request)
        .then(response => {
          this.leaved_search_status = false;
          this.leavedStudentList = response.data;
          this.isLoading = false;
        })
        .catch(error => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
          console.log("Former Student Lists API Error", error);
        });
    },

    searchStudent() {
      this.isLoading = true;
      this.searchSelectedCb = [];
      this.checkAll = false;
      this.unSelectedCb = [];
      this.idArray = [];
      this.nextPageCheckAll = false;
      this.$router.replace({
        query: {
          ...this.$route.query,
          // reset to page 1 on new search
          active_page: 1,
          leaved_page: 1,
          // serialize data form filters:
          name: this.name || undefined,
          parent_no: this.parentNo || undefined,
          phone: this.phone || undefined,
          grade_id: this.grade_id || undefined,
          section_id: this.section_id || undefined,
          gender: this.gender || undefined,
          year: this.year || undefined,
          search_status: true,
          leaved_search_status: true

        }
      });
      this.searchedData = this.searchParams;
      this.isSearched = true;
      this.searchActiveStudent(1);
      this.searchLeavedStudent(1);
    },

    searchActiveStudent(page = 1) {
      var request = {
        params: {
          ...this.searchParams,
          leavedStatus: false
        }
      }
      axios.get("/student/search/result?page=" + page, request)
        .then(response => {
          this.deleterow();
          this.isLoading = false;
          this.search_status = true;
          this.studentList = response.data;
          this.idArray = [];
          this.studentList.data.forEach(e => {
            if (e.status !== 1 && e.result == null) {
              this.idArray.push(e.class_student_id);
            }
            if (e.result != null) {
              this.unSelectedCb.push(e.class_student_id);
            }
          });

          if (this.checkAll || this.nextPageCheckAll) {

            this.unSelectedCb = new Set(this.unSelectedCb);
            let removedArr = this.idArray.filter((name) => {
              return !this.unSelectedCb.has(name);
            });

            this.searchSelectedCb = this.searchSelectedCb.concat(removedArr);
            this.searchSelectedCb = [...new Set(this.searchSelectedCb)];
            this.idArray = this.idArray.concat(this.idArray);
            this.idArray = [...new Set(this.idArray)];
            this.unSelectedCb = [...new Set(this.unSelectedCb)];
          }
        })
        .catch(error => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
          console.log("Active Student Search API Error", error);
        });
    },

    searchLeavedStudent(page = 1) {
      var request = {
        params: {
          ...this.searchParams,
          leavedStatus: true
        }
      }

      axios.get("/student/search/result?page=" + page, request)
        .then(response => {
          this.leaved_search_status = true;
          this.leavedStudentList = response.data;
          this.isLoading = false;
        })
        .catch(error => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
          console.log("Leaved Student Search API Error", error);
        });
    },

    reset() {
      // Clear input-bound variables
      this.name = '';
      this.parentNo = '';
      this.phone = '',
        this.selectedGrade = 0;
      this.selectedSection = 0;
      this.selectedGender = 0;
      this.selectedYear = 0;
      this.grade_id = '';
      this.section_id = '';
      this.gender = '';
      this.year = '';
      this.search_status = false;
      this.leaved_search_status = false;

      // Reset Array
      this.gradeArr = this.sectionArr = [{ id: 0, text: "All" }];

      // Remove all query params and reset page numbers
      this.$router.replace({
        query: {}
      });
      // Reload the default student lists
      this.isLoading = true;
      this.getStudentList(1);
      this.getLeavedStudentList(1);
      this.isSearched = false;
    },

    confirmDelete(id, studentId, parentId) {
      if (window.confirm("Are you sure you want to delete?")) {
        this.deleteStudent(id, studentId, parentId);
      }
    },

    // hard delete confrimation
    confirmDeleteFormerStudent(studentId) {
      if (window.confirm("Are you sure you want to delete?")) {
        this.deleteFormerStudent(studentId);
      }
    },

    deleteStudent(id, studentId, parentId) {
      var request = {
        params: {
          student_id: studentId,
          campus_id: store.state.user.campus_id
        }
      }
      let activePage = parseInt(this.$route.query.active_page) || 1;
      let leavedPage = parseInt(this.$route.query.leaved_page) || 1;

      if (document.querySelector('#active-table tbody').children.length == 1) {
        activePage = activePage - 1;
        leavedPage = leavedPage - 1;
        this.$router.replace({
          query: {
            active_page: activePage,
            leaved_page: leavedPage,
          },
        })
      }

      axios.delete("/student/delete/" + id + '/' + parentId, request)
        .then(response => {
          if (response.data.success == true) {
            this.isLoading = true;
            if (this.search_status) {
              this.restoreFiltersFromQuery();
              this.searchActiveStudent(activePage);
            } else {
              this.getStudentList(activePage);
            }

            if (this.leaved_search_status) {
              this.restoreFiltersFromQuery();
              this.searchLeavedStudent(leavedPage);
            } else {
              this.getLeavedStudentList(leavedPage);
            }
            this.$notification.success('Student Deleted Successfully', {
              timer: 3,
              position: "bottomCenter"
            });
          }
        })
        .catch(error => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
          console.log("Student Delete Error->", error);
        });
    },

    // hard delete the student
    deleteFormerStudent(studentId) {
      let activePage = parseInt(this.$route.query.active_page) || 1;
      let leavedPage = parseInt(this.$route.query.leaved_page) || 1;

      if (document.querySelector('#active-table tbody').children.length == 1) {
        activePage = activePage - 1;
        leavedPage = leavedPage - 1;
        this.$router.replace({
          query: {
            active_page: activePage,
            leaved_page: leavedPage,
          },
        })
      }

      axios.delete("/student/delete-former/" + studentId)
        .then(response => {
          if (response.data.success == true) {
            this.isLoading = true;
            if (this.search_status) {
              this.restoreFiltersFromQuery();
              this.searchActiveStudent(activePage);
            } else {
              this.getStudentList(activePage);
            }

            if (this.leaved_search_status) {
              this.restoreFiltersFromQuery();
              this.searchLeavedStudent(leavedPage);
            } else {
              this.getLeavedStudentList(leavedPage);
            }
          }
        })
        .catch(error => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
          console.log("Student Delete Error->", error);
        });
    },

    confirmActivate(id, parentId) {
      if (window.confirm("Are you sure you want to activate?")) {
        this.activateStudent(id, parentId);
      }
    },

    activateStudent(id, parentId) {
      axios.delete("/student/activate/" + id + '/' + parentId)
        .then(response => {
          if (response.data.success == true) {
            this.isLoading = true;
            this.getStudentList();
            this.getLeavedStudentList();
          }
        })
        .catch(error => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
          console.log("Student Activate Error->", error);
        });
    },

    checkPassFailValidate(idArr, result) {
      this.passFailDisable = true;
      this.passFailResult = result;
      var request = {
        search_status: this.search_status,
        checkAll: this.checkAll,
        nextPageCheckAll: this.nextPageCheckAll,
        unSelectedCb: this.unSelectedCb,
        student_ids: idArr,
        result: result,
        campusMaxGrade: this.maxGradeId,
        campus_id: store.state.user.campus_id,
        created_id: store.state.user.id
      }

      if (this.search_status) {
        var searchRequest = {
          name: this.name,
          parent_no: this.parentNo,
          phone: this.phone,
          grade_id: this.grade_id,
          section_id: this.section_id,
          gender: this.gender,
          year: this.year,
          campus_id: store.state.user.campus_id,
          leavedStatus: false
        }
        request = Object.assign({}, searchRequest, request);
      }

      axios.post("/student/checkPassFail", request, {
        headers: {
          'Content-Type': 'application/json',
        }
      }).then(response => {
        if (response.data.success == true) {
          this.passFailDisable = false;
          this.$bvModal.show('modal-1');
        }
      })
        .catch(error => {
          this.passFailDisable = false;
          if (error.response && error.response.status === 422) {
            const errors = error.response.data.errors;
            let message = error.response.data.message + '\n\n' + errors['student_ids'];

            alert(message.trim());
          } else {
            alert('An unexpected error occurred.');
          }
        });
    },

    setPassFail(idArr, result, classId, yearId) {
      let activePage = parseInt(this.$route.query.active_page);
      let leavedPage = parseInt(this.$route.query.leaved_page);
      if (document.querySelector('#active-table tbody').children.length == 1) {
        activePage = activePage - 1;
        leavedPage = leavedPage - 1;
        this.$router.replace({
          query: {
            active_page: activePage,
            leaved_page: leavedPage
          },
        })
      }
      if (classId == 0 && this.proceed) {
        this.requiredClass = true;
      } else {
        this.requiredClass = false;
      }
      if (yearId == 0 && this.proceed) {
        this.requiredYear = true;
      } else {
        this.requiredYear = false;
      }
      if (this.requiredClass == false && this.requiredYear == false) {
        var msg = result == 1 ? "Are you sure you want to update student pass?" :
          "Are you sure you want to update student fail?";
        if (window.confirm(msg)) {
          this.passFailDisable = true;
          this.isLoading = true;
          this.$bvModal.hide('modal-2');
          var request = {
            search_status: this.search_status,
            checkAll: this.checkAll,
            nextPageCheckAll: this.nextPageCheckAll,
            unSelectedCb: this.unSelectedCb,
            student_ids: idArr,
            result: result,
            campusMaxGrade: this.maxGradeId,
            campus_id: store.state.user.campus_id,
            created_id: store.state.user.id,
            selected_class_id: classId,
            selected_year_id: yearId
          }

          if (this.search_status) {
            var searchRequest = {
              name: this.name,
              parent_no: this.parentNo,
              phone: this.phone,   //to check
              grade_id: this.grade_id,
              section_id: this.section_id,
              gender: this.gender,
              year: this.year,
              campus_id: store.state.user.campus_id,
              leavedStatus: false
            }
            request = Object.assign({}, searchRequest, request);
          }

          axios.post("/student/setPassFail", request, {
            headers: {
              'Content-Type': 'application/json',
            }
          })
            .then(response => {
              if (response.status == 204) {
                this.submitted = false;
                this.getSection(this.grade, {
                  params: {
                    campus_id: store.state.user.campus_id
                  }
                });
                this.passFailDisable = false;
                this.isLoading = false;
                return;
              }
              if (response.data.success == true) {
                this.isLoading = false;
                this.passFailDisable = false;
                this.checkAll = false;
                this.selectedCb = [];
                if (this.search_status) {
                  this.restoreFiltersFromQuery();
                  this.searchActiveStudent(activePage);
                } else {
                  this.getStudentList(activePage);
                }

                if (this.leaved_search_status) {
                  this.restoreFiltersFromQuery();
                  this.searchLeavedStudent(leavedPage);
                } else {
                  this.getLeavedStudentList(leavedPage);
                }
                this.checkAll = false;
                this.selectedCb = [];
                var resMsg = result == 1 ? "Setting Student Pass Successfully" : "Setting Student Fail Successfully";
                this.$notification.success(resMsg, {
                  timer: 3,
                  position: "bottomCenter"
                });
              } else {
                this.isLoading = false;
                this.passFailDisable = false;
                alert(response.data.msg);
              }
            })
            .catch(error => {
              if (error.response.status == 401) {
                this.$store.commit('logout');
                window.location.replace('login');
              }
              this.isLoading = false;
              this.passFailDisable = false;
              console.log("Student Pass/Fail API Error", error.errors);
            });
        } else {
          this.passFailDisable = false;
          this.isLoading = false;
        }
      }
    },

    showCreate() {
      this.$router.push({
        path: "/student/create"
      });
    },

    showEdit(id) {
      this.$router.push({
        name: "studentEdit",
        params: {
          id: id
        }
      });
    },

    showDetail(id, leavedStatus) {
      this.$router.push({
        name: "studentProfile",
        params: {
          id: id,
          leavedStatus: leavedStatus
        },
        query: {
          active_page: this.activeCurrentPage,
          leaved_page: this.leavedCurrentPage
        }
      });
    },

    changeEvent(val, fieldName) {
      this.$set(this, fieldName, val);

      if (fieldName == 'grade_id') {
        this.sectionArr = [];
        this.section_id = '';
        this.selectedSection = '';
        this.getSection(this.grade_id, this.year);
      }
      if (fieldName == 'year') {
        this.gradeArr = [];
        this.sectionArr = [];
        this.section_id = '';
        this.selectedSection = '';
        this.grade_id = '';
        this.selectedGrade = '';
        this.getGradeNameByAcademicYear(this.year);
      }
      if (fieldName == 'class_id') {
        this.proceed = false;
      }
      if (fieldName == 'year_id') {
        this.proceed = false;
        this.class_id = 0;
      }
    },

    getSection($gradeId, $yearId) {
      axios.get("/class/getSection/" + $gradeId, {
        params: {
          academic_year: $yearId,
          campus_id: store.state.user.campus_id
        }
      })
        .then(res => {
          let $defaultSelectOption = [{
            'id': 0,
            'text': 'All'
          }];
          this.sectionArr = $defaultSelectOption.concat(res.data[0]);
          this.isLoading = false;
        }).catch((error) => {
          if (error.response.status == 401) {
            this.$router.push({
              name: "login"
            });
          }
          this.isLoading = false;
        });
    },

    getTemplateLink() {
      var request = {
        params: {
          campus_id: store.state.user.campus_id
        }
      }
      axios.get("student/getStudentTemplateLink", request, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then(res => {
        this.templatelLink = res.data;
      }).catch((error) => {
        if (error.response.status == 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        }
        this.isLoading = false;
      });
    },

    chooseFile() {
      this.$refs.fileUploader.value = '';
      document.getElementById('student-upload').click();
    },

    showModel(id, result) {
      this.currentId = id;
      this.passFailResult = result;
      this.$bvModal.show('modal-1');
    },

    hideModal1() {
      this.class_id = 0;
      this.year_id = 0;
      this.requiredClass = false;
      this.requiredYear = false;
      this.$bvModal.hide('modal-1');
    },

    onStudentFileChange() {
      this.invalidFile = false;
      let selectedFile = document.getElementById('student-upload').files;
      if (selectedFile.length) {
        let file = selectedFile[0];
        if (file.type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
          this.studentFileName = file.name;
          this.studentFile = file;
        } else {
          this.invalidFile = true;
        }
      }
      this.disabled = false;
    },

    importFile() {
      this.submitted = true;
      this.disabled = true;
      if (this.$v.$invalid) {
        this.disabled = false;
        return;
      } else {
        let activePage = parseInt(this.$route.query.active_page) || 1;
        let leavedPage = parseInt(this.$route.query.leaved_page) || 1;

        if (document.querySelector('#active-table tbody').children.length == 1) {
          activePage = activePage - 1;
          leavedPage = leavedPage - 1;
          this.$router.replace({
            query: {
              active_page: activePage,
              leaved_page: leavedPage,
            },
          })
        }
        this.isLoading = true;
        let data = new FormData();
        data.append('student_xlsx', this.studentFile);
        data.append('campus_id', store.state.user.campus_id);
        data.append('created_id', store.state.user.id);
        data.append('client_type', store.state.setting.clientType);
        axios.post("student/importStudent", data, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }).then(response => {
          if (response.data.success == true) {
            this.$notification.success(response.data.msg, {
              timer: 3,
              position: "bottomCenter"
            });
            this.disabled = false;
            if (this.search_status) {
              this.restoreFiltersFromQuery();
              this.searchActiveStudent(activePage);
            } else {
              this.getStudentList(activePage);
            }

            if (this.leaved_search_status) {
              this.restoreFiltersFromQuery();
              this.searchLeavedStudent(leavedPage);
            } else {
              this.getLeavedStudentList(leavedPage);
            }
            this.clearFile();
          } else {
            this.isLoading = false;
            this.disabled = false;
            this.clearFile();
            alert(response.data.msg);
          }
        }).catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
      }
    },

    clearFile() {
      this.studentFile = '';
      this.studentFileName = '';
      document.getElementById('student-upload').value = '';
      this.submitted = false;
      this.disabled = false;
      this.invalidFile = false;
    },

    excelDownload(status) {
      this.isLoading = true;
      const params = this.isSearched && this.searchedData
        ? {
          ...this.searchedData,
          status: status,
          search_status: this.search_status
        }
        : {
          campus_id: this.$store.state.user.campus_id,
          status: status,
          search_status: this.search_status
        };
      axios.get('/student/excelDownload', {
        params,
        responseType: 'arraybuffer'
      })
        .then(response => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement('a');
          fileLink.href = fileURL;
          let date = new Date();
          let filename_status = status == 'leave' ? 'former' : 'active';
          fileLink.setAttribute('download', filename_status + `_student_list_${date.getFullYear()}${(date.getMonth() + 1) < 9 ? 0 : ''}${(date.getMonth() + 1)}${date.getDate() < 9 ? 0 : ''}${date.getDate()}.xlsx`);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.isLoading = false;
        }).catch(error => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    toggleRow(gradeResult, rowIndex) {
      const indexPos = this.saveIndexes.indexOf(rowIndex);

      if (this.saveIndexes.includes(rowIndex)) {
        this.removeRow(rowIndex);
        this.saveIndexes.splice(indexPos, 1);
      } else {
        this.addRow(gradeResult, rowIndex);
        this.saveIndexes.push(rowIndex);
      }
    },

    removeRow(rowIndex) {
      const addedRows = document.getElementsByClassName(`row-add-${rowIndex}`);
      Array.from(addedRows).forEach(el => el.remove());

      const mainRow = document.getElementsByClassName('row-' + rowIndex)[0];
      if (mainRow) {
        const rowTds = mainRow.children;
        for (let i = 0; i < 11; i++) {
          if (i === 8 || i === 9) continue;
          rowTds[i].removeAttribute('rowspan');
          rowTds[i].removeAttribute('class');
        }
      }
    },

    deleterow() {
      this.saveIndexes = [];
      const rowAdd = document.getElementsByClassName('row-add');
      Array.from(rowAdd).forEach(element => {
        element.remove();
      });
      const cols = document.getElementsByClassName('addSpan');
      Array.from(cols).forEach(element => {
        element.removeAttribute('rowspan');
        element.removeAttribute('class');
      });
    },

    addRow(gradeResult, rowIndex) {
      this.tmpClasses = [];
      this.tmpClasses = gradeResult.slice(0);
      this.tmpClasses.splice(0, 1);

      var table = document.getElementById('active-table');
      var originalRowCount = table.rows.length;
      var afterRow = document.getElementsByClassName('row-' + (rowIndex + 1));
      var checkedRow = document.getElementsByClassName('row-' + rowIndex);
      var rowTd = checkedRow[0].children;
      for (let i = 0; i < 11; i++) {
        if (i == 8 || i == 9) continue;

        rowTd[i].setAttribute('rowspan', this.tmpClasses.length + 1);
        rowTd[i].className = 'addSpan';
      }
      var fragment = document.createDocumentFragment();
      this.tmpClasses.forEach(e => {
        var newRow = document.createElement("tr");
        newRow.classList.add('row-add', `row-add-${rowIndex}`);
        var rowTpl = `
        <td data-label="Class Name">
            ${e.grade}
        </td>
        <td data-label="Exam Result" class="exam-result">
              ${e.status}
        </td>
        `
        newRow.innerHTML = rowTpl;

        fragment.appendChild(newRow);
      })
      if (rowIndex < originalRowCount - 1) {
        table.tBodies[0].insertBefore(fragment, afterRow[0]);
      } else {
        table.tBodies[0].appendChild(fragment);
      }
    },

    handlePageChange({ page, pageKey, queryParam, searchFlag, searchFn, fetchFn }) {
      this[pageKey] = page;

      this.$router.replace({
        query: {
          ...this.$route.query,
          [queryParam]: page
        }
      });

      if (this[searchFlag]) {
        searchFn.call(this, page);
      } else {
        fetchFn.call(this, page);
      }
    },

    handleActivePageChange(page) {
      this.handlePageChange({
        page,
        pageKey: 'activeCurrentPage',
        queryParam: 'active_page',
        searchFlag: 'search_status',
        searchFn: this.searchActiveStudent,
        fetchFn: this.getStudentList
      });
    },

    handleLeavedPageChange(page) {
      this.handlePageChange({
        page,
        pageKey: 'leavedCurrentPage',
        queryParam: 'leaved_page',
        searchFlag: 'leaved_search_status',
        searchFn: this.searchLeavedStudent,
        fetchFn: this.getLeavedStudentList
      });
    },

    restoreFiltersFromQuery() {
      this.selectedCb = [];
      this.searchSelectedCb = [];
      this.name = this.$route.query.name || '';
      this.parentNo = this.$route.query.parent_no || '';
      this.phone = this.$route.query.phone || '';
      this.grade_id = this.$route.query.grade_id ? Number(this.$route.query.grade_id) : 0;
      this.section_id = this.$route.query.section_id ? Number(this.$route.query.section_id) : 0;
      this.gender = this.$route.query.gender || '';
      this.year = this.$route.query.year || '';

      this.selectedGrade = parseInt(this.grade_id) || 0;
      this.selectedSection = parseInt(this.section_id) || 0;
      this.selectedGender = parseInt(this.gender) || 0;
      this.selectedYear = parseInt(this.year) || 0;
    }
  },

  mounted() {
    this.isLoading = true;

    const activePage = parseInt(this.$route.query.active_page) || 1;
    const leavedPage = parseInt(this.$route.query.leaved_page) || 1;

    this.activeCurrentPage = activePage;
    this.leavedCurrentPage = leavedPage;

    // detect if any search filters in the URL
    const hasFilters =
      this.$route.query.name ||
      this.$route.query.parent_no ||
      this.$route.query.grade_id ||
      this.$route.query.section_id ||
      this.$route.query.gender ||
      this.$route.query.year ||
      this.$route.query.search_status === 'true' ||
      this.$route.query.leaved_search_status === 'true';

    const firstVisit = !sessionStorage.getItem('visited');
    if (firstVisit) {
      this.getStudentList(activePage);
      this.getLeavedStudentList(leavedPage);

      sessionStorage.setItem('visited', 'true');
    } else {
      if (hasFilters) {
        // restore filter fields from the query
        this.name = this.$route.query.name || '';
        this.parentNo = this.$route.query.parent_no || '';
        this.phone = this.$route.query.phone || '';
        this.grade_id = this.$route.query.grade_id ? Number(this.$route.query.grade_id) : 0;
        this.section_id = this.$route.query.section_id ? Number(this.$route.query.section_id) : 0;
        this.gender = this.$route.query.gender || '';
        this.year = this.$route.query.year || '';
        this.search_status = this.$route.query.search_status || false;
        this.leaved_search_status = this.$route.query.leaved_search_status || false;
        this.getGradeNameByAcademicYear(this.year);
        this.getSection(this.grade_id, this.year);
        // Set Select2 v-model values AFTER restoring raw values
        this.selectedGrade = parseInt(this.grade_id) || 0;
        this.selectedSection = parseInt(this.section_id) || 0;
        this.selectedGender = parseInt(this.gender) || 0;
        this.selectedYear = parseInt(this.year) || 0;
        // call the search loader
        this.searchActiveStudent(activePage);
        this.searchLeavedStudent(leavedPage);
      } else {
        // no filters → normal list
        this.getStudentList(activePage);
        this.getLeavedStudentList(leavedPage);
      }
    }

    this.getMaxGradeByCampus();
    this.getTemplateLink();
    this.getAcademicYear();
    this.getStudentList();
    this.getLeavedStudentList();
    this.getCurrentAndNextYear();
    window.studentListComponent = this;
  },
};
